
export function getDistance (coordinates, appConfig) {
    if (!appConfig.geoLocation ||
        !coordinates.latitude ||
        !coordinates.longitude
    ) {
        return;
    }

    function calculateDistance (p1, p2) {
        let rad = function (x) {
            return x * Math.PI / 180;
        };
        let R = 6378137; // Earth’s mean radius in meter
        let dLat = rad(p2.latitude - p1.latitude);
        let dLong = rad(p2.longitude - p1.longitude);
        let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(rad(p1.latitude)) * Math.cos(rad(p2.latitude)) *
                Math.sin(dLong / 2) * Math.sin(dLong / 2);
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        let d = R * c;

        return d; // returns the distance in meter
    }

    return calculateDistance(appConfig.geoLocation, {
        latitude: parseFloat(coordinates.latitude),
        longitude: parseFloat(coordinates.longitude),
    });
}

export function requestCurrentPosition (appConfig, callback) {
    if (appConfig.geoLocation && callback) {
        callback();
    }

    if (window.navigator.geolocation && !appConfig.geoLocation) {
        appConfig.geoLocation = {
            pending: true,
        };

        window.navigator.geolocation.getCurrentPosition(location => {
            appConfig.geoLocation = {
                latitude: location.coords.latitude,
                longitude: location.coords.longitude,
                pending: false,

            };
            if (callback) {
                callback();
            }
        }, () => {
            appConfig.geoLocation = null;
            if (callback) {
                callback();
            }
        });
    }
}
